import {whitelabelling as Whitelabelling} from 'whitelabelling';

const RESEND_REMINDER_WAIT_PERIOD_MILLISECONDS = 30000;

export const VerifyEmailStepController = [
    '$scope', '$http', '$location', '$timeout',
    function($scope, $http, $location, $timeout) {
        $scope.groupName = 'Verify Email';
        $scope.hideNav = false;
        $scope.withHero = false;
        $scope.autoAdvance = true;
        $scope.finalStep = 1;
        $scope.template = Evisors.config.cdnRootWhitelabel + 'asset/partials/registration/controllers/stepGroups/verifyEmail.html';

        $scope.supportEmail = Whitelabelling.supportEmail;

        $scope.canSendReminder = true;
        $scope.error = null;
        $scope.hasSent = false;

        $scope.goToPreviousStep = function() {
            $location.path('/personal_info/1');
        };

        $scope.$watch('registrationData.User.hasVerifiedEmail', function(newVal) {
            // If we get a verified email somehow, get out of here!
            if (newVal === true) {
                // Send back to root, to let the controller figure it out.
                $location.path('/');
            }
        });

        $scope.sendReminder = function() {
            $scope.canSendReminder = false;
            $scope.error = null;
            $scope.hasSent = true;
            let data = {};

            $http.post('/resend-email-verification.json').then(function(data) {
                // OK, we're waiting. Don't let them keep slapping the button.
                $timeout(() => {
                    $scope.canSendReminder = true;
                    $scope.hasSent = false;
                }, RESEND_REMINDER_WAIT_PERIOD_MILLISECONDS);
            }, function(err) {
                if (err.status === 409) {
                    // You already were verified... Let registration figure out where to put you.
                    $location.path('/');
                } else {
                    $scope.error = err.data.data.error;
                    console.error(err);
                    $scope.canSendReminder = true;
                    $scope.hasSent = false;
                }
            });
        };
    },
];
